var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-inwards-animation',{attrs:{"elements":[
        {
            element: function () { return _vm.$refs.section; },
        },
        {
            element: function () { return _vm.$refs.left; },
            direction: 'right',
        },
        {
            element: function () { return _vm.$refs.right; },
            direction: 'left',
        } ]}},[_c('div',{directives:[{name:"test",rawName:"v-test:recipeDetailsSection",arg:"recipeDetailsSection"}],ref:"section",staticClass:"recipe-details-section",attrs:{"id":"recipe-details-section"}},[_c('b-container',[_c('b-row',{staticClass:"content-row"},[_c('b-col',{ref:"left",staticClass:"animate",attrs:{"lg":"5","xl":"4"}},[_c('div',{staticClass:"recipe-ingredients-container"},[_c('recipe-ingredients',{attrs:{"ingredients":_vm.ingredients}})],1)]),_vm._v(" "),_c('b-col',{ref:"right",staticClass:"animate",attrs:{"lg":"7","xl":"8"}},[_c('div',{staticClass:"recipe-instructions-container"},[_c('recipe-instructions',{attrs:{"title":_vm.instructions.title,"steps":_vm.instructions.steps,"sub-title":_vm.instructions.subTitle}})],1)])],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }